export default "__VITE_ASSET__61ef2164__"